import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'Components/UI/Tooltip';
import IconField from '../IconField';
import './index.css';

function copyEmail(email) {
  const copy = document.createElement('textarea');
  copy.value = email;
  copy.setAttribute('readonly', '');
  copy.style = { position: 'absolute', left: '-9999px' };
  document.body.appendChild(copy);
  copy.select();
  document.execCommand('copy');
  document.body.removeChild(copy);
}

function UserEmailAddressClipboard({ email, allAddresses, spouseEmail }) {
  const [internal, setInternal] = useState(false);
  const [error, setError] = useState(false);
  const [titleInternal, setTitleInternal] = useState(error || 'Click to copy household internal email.');
  const [titleExternal, setTitleExternal] = useState('Click to copy household external email.');

  useEffect(() => {
    setInternal(allAddresses.find(e => e.attr('type') === 'generated'));
  }, [email]);

  function onClick(e) {
    e.preventDefault();
    if (!internal) {
      setError('Unable to retrieve an internal household email right now, please try again later.');
      return;
    }
    copyEmail(internal.attr('address'));
    setTitleInternal('Copied');
  }

  function onClickExternal(e, addr) {
    e.preventDefault();
    copyEmail(addr);
    setTitleExternal('Copied');
  }

  return (
    <div className="email-copy-wrapper">
      <Tooltip
        title={titleInternal}
        placement="left"
        onVisibleChange={(visible) => {
          if (!visible) {
            setTitleInternal(error || 'Click to copy household internal email.');
          }
        }}
      >
        <IconField
          icon="dashboardEmail"
          className="email-copy-icon"
          onClick={onClick}
        />
      </Tooltip>
      <div className="email-copy-test">
        <Tooltip
          title={titleExternal}
          placement="right"
          overlayClassname="email-external-tooltip"
          onVisibleChange={(visible) => {
            if (!visible) {
              setTitleExternal('Click to copy household internal email.');
            }
          }}
        >
          <div onClick={e => onClickExternal(e, email)} role="presentation">
            {email}
          </div>
        </Tooltip>
        {spouseEmail && (
          <Tooltip
            title={titleExternal}
            placement="right"
            overlayClassname="email-external-tooltip"
          >
            <div
              onClick={e => onClickExternal(e, spouseEmail)}
              role="presentation"
            >
              {spouseEmail}
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
}

UserEmailAddressClipboard.propTypes = {
  email: PropTypes.string,
  spouseEmail: PropTypes.string,
  allAddresses: PropTypes.array,
};

UserEmailAddressClipboard.defaultProps = {
  email: 'No email address',
  spouseEmail: undefined,
  allAddresses: [],
};

export default UserEmailAddressClipboard;
